<script lang="ts" setup>
import EpaperCards from '../../components/epaper/EpaperCards.vue'
import EpaperIcons from '../../components/epaper/EpaperIcons.vue'
import EpaperPharmacy from '../../components/epaper/EpaperPharmacy.vue'
import EpaperApofinderWidget from '../../components/epaper/EpaperApofinderWidget.vue'

const { t } = useTranslation()
const { isDesktop } = useDevice()

const { epaperUrl } = useEpaper()
const userStore = useUserStore()

const epaperLpDesktopBanner = useUrlResource('epaper/epaper-lp-banner.jpg')
const epaperLpMobileBanner = useUrlResource('epaper/epaper-lp-banner-mobile.jpg')

const epaperLpBanner = computed(() => {
  return isDesktop ? epaperLpDesktopBanner.value : epaperLpMobileBanner.value
})

const googleAnalyticsTracking = isClient ? useGoogleAnalytics() : undefined

const triggerEpaperLandingPageSubscribeButtonClickEvent = () => {
  googleAnalyticsTracking?.promotionClickEvent(1, 'copy-epaper')
}
</script>

<template>
  <div>
    <IaNuxtLink
      :to="epaperUrl"
      h="full"
      w="full"
    >
      <NuxtImg
        :src="epaperLpBanner"
        alt="Epaper banner"
        width="1110"
        height="408"
        loading="lazy"
        decoding="auto"
      />
    </IaNuxtLink>
    <IaHeading
      :level="3"
      as:="h2"
      font-700
      mt-12
    >
      {{ t('epaper.landingPage.heading.1') }}
    </IaHeading>
    <IaParagraph
      mt-6
      font-400
    >
      {{ t('epaper.landingPage.paragraph.1') }}
    </IaParagraph>
    <IaParagraph
      mt-6
      font-400
    >
      {{ t('epaper.landingPage.paragraph.2') }}
    </IaParagraph>
    <IaNuxtLink
      :to="epaperUrl"
      @click="triggerEpaperLandingPageSubscribeButtonClickEvent()"
    >
      <IaButton
        mt-4
        class="normal-case !lt-sm:w-full"
      >
        {{ t('epaper.landingPage.button.subscribe') }}
      </IaButton>
    </IaNuxtLink>
    <div
      flex="~ col gap-6 lg:row"
      mt-12
    >
      <EpaperIcons flex="~ col lg:row gap-4" />
    </div>
    <div
      flex="~ col gap-6 lg:row"
      mt-12
    >
      <EpaperCards />
    </div>
    <div
      flex="~ col gap-6 lg:row"
      mt-12
    >
      <EpaperPharmacy />
    </div>
    <ClientOnly v-if="!userStore.userId">
      <EpaperApofinderWidget />
    </ClientOnly>
  </div>
</template>
